import * as React from "react";
import * as cn from "classnames";

import styles = require("./style.less");

interface DataTableBodyProps {
    className?: string;
    children?: React.ReactNode;
}

export class DataTableBody extends React.Component<DataTableBodyProps, never> {
    render() {
        return (
            <tbody className={cn(this.props.className, styles.dataTableBody)}>
                {this.props.children}
            </tbody>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DataTable/DataTableBody.tsx